import {AppLayout} from '@/modules/layout/app-layout/components/app-layout'
import {createFileRoute, redirect} from '@tanstack/react-router'

export const Route = createFileRoute('/patient-dashboard')({
  beforeLoad: ({location}) => {
    if (location.pathname === '/patient-dashboard') {
      throw redirect({to: '/patient-dashboard/patients'})
    }
  },
  component: PatientDashboardLayout,
})

function PatientDashboardLayout() {
  return <AppLayout hideSideDrawer paddingX="4" />
}
